import { useEffect, useState } from "react"
import { Link, Loading } from "@wfp/ui"
import { useParams } from "react-router-dom"
import ExcelUploader from "../Shared/ExcelUploader/ExcelUploader"
import { useGetReportByIdQuery, usePostReportMutation } from "../../services/marketprices/reports"
import { useDownloadExcelTemplateMutation } from "../../services/marketprices/mappingSchemas"
import { formatDate } from "../../utils/helpers"
import ViewReport from "../../pages/Reports/ViewReports"

export default function UploadReportExcel() {
  const { reportId } = useParams()

  const [postReport, { error, isLoading, isSuccess, data: reportData }] = usePostReportMutation()
  const [downloadTemplate, { isLoading: isDownloading }] = useDownloadExcelTemplateMutation()
  const { data } = useGetReportByIdQuery(reportId ? +reportId : 0, { skip: !reportId })

  const [showReport, setShowReport] = useState(false)

  const handleSelect = (file?: File) => {
    if (!file || !data || !reportId) return

    const formData = new FormData()
    formData.append("files", file)

    postReport({
      file: formData,
      cid: data.adm0Code,
      msid: data.mappingSchemaId,
      rid: +reportId,
    })
  }

  useEffect(() => {
    setShowReport(isSuccess)
  }, [isSuccess])

  useEffect(() => {
    if (error) {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const { data, originalStatus } = error as any
      if (originalStatus === 500) alert("Report save failed. Please review the uploaded file for any issue.")
      else alert(data)
    }
  }, [error])

  return (
    <>
      <div className="flex justify-between">
        <div className="flex gap-x-4">
          <p>
            <strong>{data?.countryName}</strong>
          </p>
          <p>|</p>
          <p>Report N. {data?.reportId}</p>
          <p>| Created on {formatDate(data?.reportCreateDate || "")}</p>
          <p>
            |{" "}
            {data?.reportId && (
              <Link onClick={() => downloadTemplate({ reportId: data.reportId, adm0Code: data?.adm0Code })}>
                Click here to download the Default VAM Reporting Template
              </Link>
            )}
          </p>
        </div>
        <p>{data?.reportStatusName}</p>
      </div>

      {!isLoading && !showReport && <ExcelUploader onSelect={handleSelect} />}

      {showReport && (
        <ViewReport
          reportData={reportData}
          adm0Code={data?.adm0Code}
          countryName={data?.countryName}
          frequencyId={JSON.parse(data?.mappingSchemaJson || "{}")?.frequency}
        />
      )}

      {(isLoading || isDownloading) && <Loading />}
    </>
  )
}
